export default __webpack_public_path__ + "5d8c4880e875306ca91105a1c97cf444.png";